import $ from 'jquery';
import './app.validation'
import './app.signatureCropping'

(function (window, $) {
	// Multi-step form navigation
	function showStep(step) {
		$('.company-step').hide();
		$('.company-step-' + step).show();
		if (step === 1)
			$('.js-company-type-container').show();
		else
			$('.js-company-type-container').hide();
	}
	function toggleCompleteRegistrationBtn() {
		var isChecked = $('#AcceptTerms').is(':checked');
		$('#completeRegistrationBtn').prop('disabled', !isChecked);
	}

	$(document).on('click', '.js-btn-next', function () {
		const form = $(this).closest('form');
		if (form.valid()) {
			showStep($(this).data("step"));

			$('#companyFormContainer').find('input[type="file"].signature-fileupload').each(function () {
				InitCanvasCropper($(this));
			});
		}
	});

	$(document).on('click', '.js-btn-prev', function () {
		showStep($(this).data("step"));
	});

	// Company type selection logic
	$(document).on('change', '.js-company-type', function () {
		var selectedType = $(this).val();
		var url = '';

		if (selectedType === 'FreightForwarder') {
			url = '/FreightForwarderCompany/LoadFreightForwarderForm?companyType=' + encodeURIComponent(selectedType);
		} else if (selectedType === 'Exporter') {
			url = '/Company/LoadExporterForm?companyType=' + encodeURIComponent(selectedType);
		}

		if (url) {
			$.get(url, function (html) {
				$('#companyFormContainer').html(html);
				$.validator.unobtrusive.parse($('#companyFormContainer').find('form'));
			});
		}
	});

	$(document).on('change', '.js-company-submission-type', function(){
		const selectedValue = $(this).val();
		const submissionTypeInfoLabel = $(".js-submission-type-info-label");

		const ftaSubmissionTypeValue = submissionTypeInfoLabel.data("fta-value");
		const ftaLabel = submissionTypeInfoLabel.data("fta-label");
		const nonPrefLabel = submissionTypeInfoLabel.data("non-preferential-only-label");

		submissionTypeInfoLabel.html(selectedValue == ftaSubmissionTypeValue ? ftaLabel : nonPrefLabel);

		if(selectedValue == ftaSubmissionTypeValue)
		{
			$('.js-fta-submission-chamber').show();
		}else{
			$('.js-fta-submission-chamber').hide();
		}

	});

	$(document).on('change', '.js-company-transaction-type', function () {
		const AuthorisationType = {
			FTA: 1,
			NonPreferential: 2
		};

		var selectedValue = parseInt($(this).val());

		// Check if FTA or Non Preferetial flag is set using bitwise AND
		var hasFTA = (selectedValue & AuthorisationType.FTA) === AuthorisationType.FTA;

		// Enable/disable based on flags
		if (hasFTA) {
			$('.js-fta-chamber-select').prop('disabled', false);
		} else {
			$('.js-fta-chamber-select').prop('disabled', true);
		}
	});

	// Optionally, show the first step on page load
	showStep(1);
	toggleCompleteRegistrationBtn();

	$(document).on('change', '#AcceptTerms', toggleCompleteRegistrationBtn);

	$(document).on('change', '.js-postal-address-toggle', function () {
		if ($(this).is(':checked')) {
			$('.postal-address-container').slideUp().find('input, select').prop('disabled', true);
		}
		else {
			$('.postal-address-container').slideDown().find('input, select').prop('disabled', false);
		}
	});

	// trigger on page load
	$('.js-postal-address-toggle').trigger('change');

	// Show correct form on page load if a radio is pre-selected
	var preselected = $('.js-company-type:checked').val();
	if (preselected) {
		$('.js-company-type:checked').trigger('change');
	}
})(window, jQuery);
